{
  "title": "Gab AI — AI Chat, Work Agent & Creative Tools",
  "description": "Chat with leading AI models and create websites, documents, code, videos, and games. Try Gab AI on the web, Mac, iOS, Android, and in your browser.",
  "headline": "All the top AI models. One agent that does the work.",
  "kicker": "AI that works.",
  "intro": "Chat with GPT, Claude, Gemini, and more on one account. Or hand off the whole job and get back a website, deck, document, video, or game you can edit and share.",
  "faqTitle": "A few things worth knowing.",
  "faqs": [
    {
      "question": "What can I create with Gab AI?",
      "answer": "Use Gab AI for writing, research, images, video, music, and code. Work mode can build websites and playable games, create Word documents and PDFs, design PowerPoint presentations, and prepare Excel spreadsheets you can edit and share.",
      "href": "/features",
      "linkLabel": "Explore AI tools and features"
    },
    {
      "question": "How is Work mode different from AI chat?",
      "answer": "Chat helps you ask questions, explore ideas, and work through answers. Work mode gives an AI agent a computer and tools to carry out a project in multiple steps, create files, and revise them with your feedback. Work mode requires Gab AI Plus.",
      "href": "/docs/work",
      "linkLabel": "How the AI Work Agent works"
    },
    {
      "question": "Can I use Gab AI for free?",
      "answer": "Yes. Start with {{FREE_CREDITS}} free credits and no credit card required. Credit use depends on the model and task. Plus adds Work mode, premium models, and a monthly credit allowance; compare plans to choose what fits your work.",
      "href": "/pricing",
      "linkLabel": "Compare free and paid plans"
    },
    {
      "question": "Does Gab AI work on my phone and computer?",
      "answer": "Use Gab AI in your web browser or download the apps for iPhone, iPad, Android, and Mac. The browser extension brings Gab AI alongside your tabs in Chrome and Brave. Sign in with the same account across your devices.",
      "href": "/download",
      "linkLabel": "Download the Gab AI apps"
    },
    {
      "question": "Can I work with my own files?",
      "answer": "Yes. Attach documents, PDFs, spreadsheets, and other supported files to ask questions and work with their contents. Work can turn your material into new files, and the built-in editors let you review documents, slides, and spreadsheets beside the conversation.",
      "href": "/docs/editors",
      "linkLabel": "Explore file editors"
    },
    {
      "question": "Which AI models can I use?",
      "answer": "Choose models from providers including GPT, Claude, Gemini, DeepSeek, Qwen, and Kimi, alongside Gab AI's Arya. Switch models between messages or let Auto choose one suited to your request. Availability and credit use vary by model.",
      "href": "/models",
      "linkLabel": "Browse the AI model library"
    }
  ]
}
